import { z } from "zod";

/**
 * ControleInspecaoMaquinaSchema
 */

export const ControleInspecaoMaquinaSchema = z.object({
  dataInspecao: z.coerce.date().nullable().default(null),
  idMaquinaEquip: z.coerce.number({ required_error: 'Este campo deve ser preenchido!' }),
  codigoMaquinaEquip: z.string().nullable().default(null),
});

/**
 * ControleInspecaoMaquinaForm
 */

export type ControleInspecaoMaquinaForm = z.infer<typeof ControleInspecaoMaquinaSchema>;
